// Script Sconti Cart Label - UpCart (Shadow DOM)
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {
    let cartQty = 0;

    function getDiscount(qty) {
        if (qty >= 50) return 50;
        if (qty >= 35) return 40;
        if (qty >= 20) return 30;
        if (qty >= 10) return 25;
        if (qty >= 5) return 20;
        if (qty >= 3) return 15;
        if (qty >= 2) return 10;
        return 0;
    }

    function injectUI(root) {
        if (!root) return;
        const header = root.querySelector('.upcart-internal-header');
        if (!header) return;

        // Bannerino
        let wrapper = root.querySelector('#js-cumulative-discount-wrapper');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.id = 'js-cumulative-discount-wrapper';
            header.after(wrapper);
        }

        let next_qty = 0, next_discount = 0;
        if (cartQty < 2)       { next_qty = 2  - cartQty; next_discount = 10; }
        else if (cartQty < 3)  { next_qty = 3  - cartQty; next_discount = 15; }
        else if (cartQty < 5)  { next_qty = 5  - cartQty; next_discount = 20; }
        else if (cartQty < 10) { next_qty = 10 - cartQty; next_discount = 25; }
        else if (cartQty < 20) { next_qty = 20 - cartQty; next_discount = 30; }
        else if (cartQty < 35) { next_qty = 35 - cartQty; next_discount = 40; }
        else if (cartQty < 50) { next_qty = 50 - cartQty; next_discount = 50; }

        if (cartQty === 0) {
            wrapper.innerHTML = '';
        } else {
            const message = next_qty > 0
                ? `Sconto articoli personalizzati: ti ${next_qty === 1 ? 'manca' : 'mancano'} <strong>${next_qty}</strong> ${next_qty === 1 ? 'articolo' : 'articoli'} per il <strong>-${next_discount}%</strong>`
                : `🎉 Hai raggiunto lo sconto massimo del <strong>-50%</strong>!`;
            wrapper.innerHTML = `<div class="custom-cumulative-discount-msg" style="background:#22c55e; color:#fff; width:100%; text-align:center; padding:10px 0; font-size:0.95em;">${message}</div>`;
        }

        // Badge prezzi
        root.querySelectorAll('.upcart-internal-cart-item').forEach((itemEl) => {
            itemEl.querySelectorAll('.custom-discount-badge').forEach(b => b.remove());
            const titleLink = itemEl.querySelector('.upcart-public-component-product-tile__title-link');
            if (!titleLink) return;
            const isEligible = titleLink.innerText.toLowerCase().includes('personalizzato') ||
                               titleLink.href.includes('personalizza');
            const discount = getDiscount(cartQty);
            if (isEligible && discount > 0) {
                const priceTarget = itemEl.querySelector('.upcart-internal-component-product-tile__price');
                if (priceTarget) {
                    const badge = document.createElement('span');
                    badge.className = 'custom-discount-badge';
                    badge.style.cssText = 'font-weight:bold; margin-left:5px; font-size:0.9em; display:inline-block;';
                    badge.textContent = `(-${discount}%)`;
                    priceTarget.appendChild(badge);
                }
            }
        });
    }

    const hostObserver = new MutationObserver(() => {
        const root = document.querySelector('#upCart')?.shadowRoot;
        if (!root) return;
        const header = root.querySelector('.upcart-internal-header');
        if (!header) return;
        if (root.querySelector('#js-cumulative-discount-wrapper')) return;

        fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
                cartQty = cart.items.reduce((total, item) => {
                    const eligible = item.vendor === "INDIANACAPSpersonalizzato" ||
                                     item.url.includes('/personalizza/') ||
                                     item.title.toLowerCase().includes('personalizzat');
                    return eligible ? total + item.quantity : total;
                }, 0);
                injectUI(root);
            });
    });

    hostObserver.observe(document.body, { childList: true, subtree: true });

    // Aggiorna quando cambia quantità
    const originalFetch = window.fetch;
    window.fetch = function () {
        return originalFetch.apply(this, arguments).then((response) => {
            if (response.url.includes('/cart/')) {
                setTimeout(() => {
                    const root = document.querySelector('#upCart')?.shadowRoot;
                    fetch('/cart.js')
                        .then(r => r.json())
                        .then(cart => {
                            cartQty = cart.items.reduce((total, item) => {
                                const eligible = item.vendor === "INDIANACAPSpersonalizzato" ||
                                                 item.url.includes('/personalizza/') ||
                                                 item.title.toLowerCase().includes('personalizzat');
                                return eligible ? total + item.quantity : total;
                            }, 0);
                            injectUI(root);
                        });
                }, 600);
            }
            return response;
        });
    };
});